<template>
  <div class='EnbVazio'>{{ text }}</div>
</template>

<script>
export default {
  name: 'EnbVazio',
  props: ['text']
}
</script>

<style scoped>
.EnbVazio {
  display: flex;
  justify-content: center;
  padding-top: 10%;
  width: 100%;
  height: 80%;
  font-size: 22px;
}
</style>
